import { signal } from "@preact/signals-react"

/**
 * A counter the popup bumps whenever it marks an announcement as read.
 *
 * The bell owns the unread badge and has no way of knowing the popup just cleared one, so
 * without this notice its count would sit at whatever it was when the app loaded until the
 * next reload. A counter rather than a boolean: two announcements read in a row have to
 * produce two ticks.
 */
export const announcementsSeenTick = signal(0)

export const notifyAnnouncementSeen = () => {
	announcementsSeenTick.value = announcementsSeenTick.value + 1
}
